import { errorHandler, onSuccess } from './errors';

// eslint-disable-next-line import/prefer-default-export
export function copyToClipboard(text: string) {
  if (typeof navigator === 'undefined') {
    return;
  }

  navigator.clipboard
    .writeText(text)
    .then(() => onSuccess(`copied to clipboard`))
    .catch(errorHandler('Cannot copy to clipboard'));
}

export function downloadTextFile(
  content: string,
  fileName?: string,
  mime = 'text/plain',
) {
  if (typeof window === 'undefined') {
    return;
  }

  const elem = window.document.createElement('a');
  elem.href = window.URL.createObjectURL(new Blob([content], { type: mime }));

  if (fileName) {
    elem.download = fileName;
  }

  window.document.body.append(elem);

  elem.click();
  elem.remove();
}

export async function downloadUrl(
  fileUrl: string,
  { token = '', fileName = '' } = {},
) {
  const anchor = document.createElement('a');
  document.body.append(anchor);

  const headers = new Headers();
  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }

  return fetch(fileUrl, { headers })
    .then((response) => response.blob())
    .then((blob) => {
      const objectUrl = URL.createObjectURL(blob);

      anchor.href = objectUrl;
      if (fileName) {
        anchor.download = fileName;
      }

      anchor.click();

      URL.revokeObjectURL(objectUrl);
    });
}
